import { NgClass } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ChallengeType } from 'src/app/core/common/enums/select-challenge.enum';
import {
  CommonChallenge,
  SubChallenge,
} from '../challenges-sub-challenges.model';
import { ChallengesSubChallengesStore } from '../challenges-sub-challenges.store';

@Component({
  selector: 'app-challenge-list',
  imports: [TableModule, NgClass],
  templateUrl: './challenge-list.component.html',
  styleUrl: './challenge-list.component.scss',
})
export class ChallengeListComponent {
  store = inject(ChallengesSubChallengesStore);

  subChallenges = input<SubChallenge[]>([]);
  challengeTitle = input<ChallengeType>();
  challengeName = input<string>('');
  challengeMasterDatas = input<CommonChallenge[] | SubChallenge[]>([]);
  currentSelected = signal<SubChallenge | CommonChallenge>(
    this.store.initialSubChallenge() || this.store.initialChallengeResult(),
  );
  challengeType = ChallengeType;
  selectedChallengeChange = output<CommonChallenge>();
  selectedSubChallengeChange = output<SubChallenge>();

  handleRowSelection(challengeTitle: ChallengeType | undefined): void {
    if (challengeTitle === this.challengeType.SubChallenge) {
      this.selectedSubChallengeChange.emit(
        this.currentSelected() as SubChallenge,
      );
    } else {
      this.selectedChallengeChange.emit(
        this.currentSelected() as CommonChallenge,
      );
    }
  }
}
